export default `18 U.S.C. §2257 Records Keeping Requirements Compliance Statement
Records required to be maintained pursuant to Title 18 U.S.C. §2257 and 28 C.F.R. Part 75 are maintained by the appropriate Records Custodian and are available in accordance with applicable law. 

For instances in which Select Exposure LLC serves as the designated Records Custodian for certain content appearing on the Site, such records are maintained in accordance with applicable federal law and may be made available for inspection during normal business hours at:   

Select Exposure LLC
8 The Green, Suite B
Dover, DE 19901  

For compliance-related inquiries or assistance in identifying the originating source of specific content appearing on the Site, please contact the Select Exposure compliance department at: 
legal@selectexposure.com

Select Exposure implements commercially reasonable age-verification, identity-verification, recordkeeping, and compliance review procedures designed to support compliance with applicable legal and payment processor requirements.`;
